import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConstitutionTable from 'components/templates/constitution-table';
import Layout from 'components/templates/layout';
import { useIntl } from 'common/config/i18n';
import { MessagesMasksActions, UserInfoSelectors } from 'common/config/store';
import { StyledMainTitle, StyledListUtil } from 'common/styling/mixins';
import history from 'app-router/history';
import { MessageMask } from 'types';

const { StyledListWrapper, StyledListTitleWrapper } = StyledListUtil;

const Constitution: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useIntl();

  const canWriteConstitution = useSelector(UserInfoSelectors.hasWriteAccess('Situations'));

  useEffect(() => {
    dispatch(MessagesMasksActions.fetchMessagesMasks());
  }, [dispatch]);

  const onClickEditHandler = (constitution: MessageMask): void => {
    return history.push(`/constitution/${constitution.id}`);
  };

  return (
    <div>
      <Layout />
      <StyledListWrapper>
        <StyledListTitleWrapper>
          <StyledMainTitle>{t('ConstitutionPage', 'CONSTITUTION_REPOSITORY_PAGE_H21')}</StyledMainTitle>
        </StyledListTitleWrapper>
        <ConstitutionTable isAdmin={canWriteConstitution} onClickEdit={onClickEditHandler} />
      </StyledListWrapper>
    </div>
  );
};

export default Constitution;
